/**
 * Content carousel (slider) with extensive options to control behaviour and appearance
 * @requires https://swiperjs.com/
 */

export default (() =>
{
  window.cartzilla = window.cartzilla || {};

  function resolveModuleByName(name)
  {
    if (!name || typeof name !== 'string')
      return null;

    // 1) Prefer explicitly exported namespace (if you decide to attach modules there)
    const cartzillaModule = window.cartzilla?.swiperModules?.[name];

    if (typeof cartzillaModule === 'function')
      return cartzillaModule;

    // 2) Fallback: global lookup (works if the function is on window/globalThis)
    const globalModule = globalThis?.[name];

    if (typeof globalModule === 'function')
      return globalModule;

    return null;
  }

  function resolveSwiperModules(options)
  {
    if (!options || !Array.isArray(options.modules))
      return options;

    // If already functions, keep as-is
    if (options.modules.length > 0 && typeof options.modules[0] === 'function')
      return options;

    options.modules = options.modules
        .map(x =>
        {
          if (typeof x === 'function')
            return x;

          if (typeof x === 'string')
            return resolveModuleByName(x);

          return null;
        })
        .filter(Boolean); // drop unknown names

    return options;
  }

  window.cartzilla.initSwiper = function (value)
  {
    let options, images

    // Parse swiper options from the data attribute
    if (value.dataset.swiper !== undefined && value.dataset.swiper !== '')
    {
      options = JSON.parse(value.dataset.swiper);
      options = resolveSwiperModules(options);

      images = options?.thumbnails?.images;
    }

    if(options.scrollbar)
    {
      options.on =
      {
        init: function()
        {
          let instance = this;

          setTimeout(() =>
          {
            instance.scrollbar.updateSize();
          });
        }
      };
    }

    // Create a new Swiper instance
    /* eslint-disable no-undef */
    const swiper = new Swiper(value, options)
    /* eslint-enable no-undef */

    // Check if a controlled slider is specified
    if (options?.controlSlider)
    {
      let controlledSliders = []

      if (Array.isArray(options.controlSlider)) // Handle multiple sliders
        controlledSliders = options.controlSlider.map(selector => document.querySelector(selector));
      else // Handle single slider
        controlledSliders.push(document.querySelector(options.controlSlider));

      const swiperControlledInstances = controlledSliders.map(controlledSlider =>
      {
        const controlledSliderOptions =
          controlledSlider?.dataset.swiper &&
          JSON.parse(controlledSlider.dataset.swiper)

        // Create a new Swiper instance for each controlled slider
        /* eslint-disable no-undef */
        var instance = new Swiper(controlledSlider, controlledSliderOptions)
        /* eslint-enable no-undef */

        return instance;
      })

      swiper.controller.control = swiperControlledInstances
    }

    swiper.on("slideChange", () =>
    {
      // Firefox bug
      const activeSlide = swiper.slides[swiper.activeIndex];
      const images = activeSlide.querySelectorAll(`img[loading="lazy"]`);

      for (let image of images)
      {
        if (image && !image.complete)
        {
          // Force browser to check if image should load
          image.loading = 'eager';
        }
      }

      // hotspots?
      var popovers = value.querySelectorAll("*[data-bs-toggle='popover']");

      for (let element of popovers)
      {
        var popover = bootstrap.Popover.getOrCreateInstance(element);

        var isVisible = popover && element.getAttribute("aria-describedby") !== null;

        if (isVisible)
          popover.hide();
      }
    });
  };

  // Get all elements with the 'swiper' class
  const carousels = document.querySelectorAll('[data-swiper]')

  if (carousels.length === 0)
    return

  // Iterate over each element using the built-in forEach method
  /* eslint-disable no-unused-vars */
  for (let carousel of carousels)
    cartzilla.initSwiper(carousel);
})()
